import './polyfill'
import './utils/apiAuth'
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
// disable ServiceWorker
// import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
// disable ServiceWorker
// registerServiceWorker();
